import { render } from "./DefaultTree.vue?vue&type=template&id=3cd41b6c"
import script from "./DefaultTree.vue?vue&type=script&lang=js"
export * from "./DefaultTree.vue?vue&type=script&lang=js"
script.render = render

export default script
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QInput,QScrollArea,QTree});
